import "assets/scss/pages/home.scss";

import { Page, Swiper } from "components";
import { usePotluck } from "hooks";

export const Voting = () => {
  const { potluck } = usePotluck();

  if (!potluck) return <Page.Loader />;

  return <Swiper.Controller potluck={potluck} />;
};
